var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thumbnails-container"},_vm._l((_vm.thumbnails),function(thumb){return _c('div',{key:thumb,staticClass:"thumbnails-container__item",style:({
      width: _vm.thumbnailSize.w + 'px',
      height: _vm.thumbnailSize.h + 'px'
    })},[_c('thumbnail-image',{staticClass:"thumb-img",attrs:{"is-thumb":_vm.isThumb,"src":thumb,"loader-c-lose":_vm.loaderCLose,"fallback":_vm.$options.fallback,"alt":"thumbnail"}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }